import React from 'react';
import './style.scss';
import SelectStyled from 'react-select';

const Select = ({ id, value, defaultValue, selectedOption, handleChange, options, placeholder, isSearchable = true }) => {

  // If the selected option is not set, find the currently selected option by value.
  if (!selectedOption && value) {
    selectedOption = options.find((option) => {
      return option.value === value;
    });
  }
  return (
    <SelectStyled
      id={id}
      className="Select__select"
      classNamePrefix="Select__inner"
      value={selectedOption}
      defaultValue={defaultValue}
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
      isSearchable={isSearchable}
      theme={{
        borderRadius: 0,
        colors: {
          danger: '#DE350B',
          dangerLight: '#FFBDAD',
          neutral0: 'hsl(0, 0%, 100%)',
          neutral10: 'hsl(0, 0%, 90%)',
          neutral20: 'hsl(0, 0%, 80%)',
          neutral30: 'hsl(0, 0%, 70%)',
          neutral40: 'hsl(0, 0%, 60%)',
          neutral5: 'hsl(0, 0%, 95%)',
          neutral50: 'hsl(0, 0%, 50%)',
          neutral60: 'hsl(0, 0%, 40%)',
          neutral70: 'hsl(0, 0%, 30%)',
          neutral80: 'hsl(0, 0%, 20%)',
          neutral90: 'hsl(0, 0%, 10%)',
          primary: '#f0694b',
          primary25: 'hsla(0,0%,0%, 0)',
          primary50: 'hsla(0,0%,0%, 0)',
          primary75: 'hsla(0,0%,0%, 0)',
        },
      }}
    />
  );
};

export default Select;
